const DEV_CORE_API_URL = "http://localhost:8081";

function normalizeBaseUrl(url) {
	return String(url || "").trim().replace(/\/$/, "");
}

function getApiBaseUrl() {
	const configured = normalizeBaseUrl(process.env.REACT_APP_API_URL || "");

	if (!configured) {
		return DEV_CORE_API_URL;
	}

	if (/^:\d+$/.test(configured)) {
		return `http://localhost${configured}`;
	}

	if (/^localhost:\d+$/i.test(configured)) {
		return `http://${configured}`;
	}

	return configured;
}

const API_BASE_URL = getApiBaseUrl();

export async function callCoreApi(path, options = {}) {
	const {
		method = "GET",
		body = null,
		headers = {},
		credentials = "include",
	} = options;

	const normalizedPath = path.startsWith("/") ? path : `/${path}`;
	const requestHeaders = {
		...(body ? { "Content-Type": "application/json" } : {}),
		...headers,
	};

	const response = await fetch(`${API_BASE_URL}${normalizedPath}`, {
		method,
		credentials,
		headers: requestHeaders,
		...(body ? { body: JSON.stringify(body) } : {}),
	});

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	if (!response.ok) {
		throw new Error(payload.error || `Core request failed (${response.status})`);
	}

	return payload;
}

